import type { FC, ReactElement, ReactNode } from 'react';

import { TrophyIcon } from '../../../components/promotionsV2/trophyIcon/TrophyIcon';
import type { Trophy } from '../../../store/slices/promotionsV2/types';
import { useModifiers } from '../../../styles/hooks/useModifiers';

import styles from './gameWingItem.module.css';

export enum DirectionProps {
  end = 'end',
  start = 'start',
}
interface GameWingItemProps {
  action?: ReactNode;
  dataTestId?: string;
  direction?: DirectionProps;
  label?: ReactNode | string;
  trophy?: Trophy;
  value?: ReactNode | string;
  isLabelAlignedRight?: boolean;
}

export const GameWingItem: FC<GameWingItemProps> = ({
  action,
  dataTestId,
  direction,
  label,
  trophy,
  value,
  isLabelAlignedRight,
}): ReactElement => {
  const mods = useModifiers(styles, 'gameWingItem', {
    end: direction === DirectionProps.end,
    start: direction === DirectionProps.start,
  });

  const labelMods = useModifiers(
    styles,
    'gameWingItem__label',
    {
      right: isLabelAlignedRight,
    },
    { withBaseClass: true }
  );

  return (
    <div className={`${styles.gameWingItem} ${mods}`} data-testid={dataTestId ? `${dataTestId}` : 'game-wing-item'}>
      {action ? <div className={styles.gameWingItem__action}>{action}</div> : null}
      <div className={styles.gameWingItem__group}>
        {label ? (
          <div className={labelMods} data-testid={dataTestId ? `${dataTestId}-label` : 'label'}>
            {trophy ? <TrophyIcon trophy={trophy} /> : null}
            {label}
          </div>
        ) : null}
        {value ? (
          <div className={styles.gameWingItem__value} data-testid={dataTestId ? `${dataTestId}-value` : 'value'}>
            {value}
          </div>
        ) : null}
      </div>
    </div>
  );
};
